import { baseApi } from "./baseApi";

const loanConditionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanConditions: builder.query({
      query: (loanId) => ({
        url: `/loans/${loanId}/conditions`,
        method: "GET",
      }),
      providesTags: (result, error, loanId) => [
        { type: "LoanConditions", id: loanId },
      ],
    }),
    updateLoanCondition: builder.mutation({
      query: ({ loanId, conditionId, body }) => ({
        url: `/loans/${loanId}/conditions/${conditionId}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanConditions", id: loanId },
      ],
    }),
  }),
});

export default loanConditionsApi;
